import React from 'react';
import { useParams } from 'react-router-dom';
import MyInvoisLayout from './components/myinvois_layout';
import ContainerComponent from '../../helpers/components/container.component';

const MyInvoisIndex = () => {
    const { token } = useParams();

    return (
        <>
            <MyInvoisLayout token={token} />
        </>
    );
}

export default MyInvoisIndex;